__turbopack_context__.v({
  "card-field-linked-badge": "CardItemEditor-module-scss-module__CCQslq__card-field-linked-badge",
  "card-property-edit-container": "CardItemEditor-module-scss-module__CCQslq__card-property-edit-container",
});
